export class LocalStorageWrapper {
   
    public static getProviderId(): number | undefined {
        return parseInt(localStorage.getItem('providerId'));
    }

    public static setProviderId(id: number): void {
        localStorage.setItem("providerId",id.toString());
    }

    public static removeProviderId() {
        localStorage.removeItem("providerId");
    }

    public static getToken(): string | undefined {
        return localStorage.getItem('token');
    }

    public static setToken(token: string): void {
        localStorage.setItem("token",token);
    }

    public static removeToken(): void {
        localStorage.removeItem("token");
    }

    public static setLocale(locale: string, languageId: number): void {
        localStorage.setItem('locale', locale);
        localStorage.setItem('languageId', languageId.toString());
    }

    public static getLocale(): string {
        return localStorage.getItem('locale')!.toString();
    }

    public static isLocaleSet(): boolean {
        return localStorage.getItem('locale') != null && localStorage.getItem('languageId') != null;
    }

    public static getLanguageId(): number {
        return parseInt(localStorage.getItem('languageId')!.toString());
    }

    public static getUserDisplayName(): string | undefined {
        return localStorage.getItem('userDisplayName')!.toString();
    }

    public static setUserDisplayName(dName: string): void {
        localStorage.setItem("userDisplayName",dName);
    }

    public static removeUserDisplayName(): void {
        localStorage.removeItem("userDisplayName");
    }

    public static setObject<T>(key: string, obj: T): void {
        localStorage.setItem(key, JSON.stringify(obj));
    }

    public static getObject<T>(key: string): T {
        return <T>JSON.parse(localStorage.getItem(key));
    }
}
